/**
 * @generated SignedSource<<da5b98bdbb3b5d45db3c08eab798efd6>>
 * @relayHash 57b4bb3acd15631c8c9dfd0bed7e9b44
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4022831f47fbe75e743cc366c372d6f1434e902abda956a325a71b539f547a6f

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HelpCenterMediaConfigOperationType = "BANNER_UPLOAD" | "LOGO_UPLOAD" | "READ" | "%future added value";
export type hubBootstrapWrapperQuery$variables = {
  cloudId: string;
  hubAri: string;
  hubEditMode: boolean;
  operationType?: HelpCenterMediaConfigOperationType | null | undefined;
  pageAri: string;
};
export type hubBootstrapWrapperQuery$data = {
  readonly helpCenter: {
    readonly " $fragmentSpreads": FragmentRefs<"hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference">;
};
export type hubBootstrapWrapperQuery = {
  response: hubBootstrapWrapperQuery$data;
  variables: hubBootstrapWrapperQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hubAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hubEditMode"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "operationType"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageAri"
},
v5 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v6 = {
  "kind": "Variable",
  "name": "operationType",
  "variableName": "operationType"
},
v7 = [
  {
    "kind": "ScalarField",
    "name": "asapIssuer"
  },
  {
    "kind": "ScalarField",
    "name": "mediaCollectionName"
  },
  {
    "kind": "ScalarField",
    "name": "mediaToken"
  },
  {
    "kind": "ScalarField",
    "name": "mediaUrl"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "hubBootstrapWrapperQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference"
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "hubBootstrapWrapperQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "ari",
                "variableName": "hubAri"
              },
              (v6/*: any*/)
            ],
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "hubMediaConfig",
            "plural": false,
            "selections": (v7/*: any*/)
          },
          {
            "alias": "pageMediaConfig",
            "args": [
              {
                "kind": "Variable",
                "name": "ari",
                "variableName": "pageAri"
              },
              (v6/*: any*/)
            ],
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "hubMediaConfig",
            "plural": false,
            "selections": (v7/*: any*/)
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "helpCenterAri",
                "variableName": "hubAri"
              }
            ],
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "type"
                  },
                  {
                    "concreteType": "HelpCenterBranding",
                    "kind": "LinkedField",
                    "name": "helpCenterBranding",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "HelpCenterLogo",
                        "kind": "LinkedField",
                        "name": "logo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "fileId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "url"
                          }
                        ]
                      },
                      {
                        "concreteType": "HelpCenterBrandingColors",
                        "kind": "LinkedField",
                        "name": "colors",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "primary"
                          }
                        ]
                      },
                      {
                        "concreteType": "HelpCenterNavigationBar",
                        "kind": "LinkedField",
                        "name": "navigationBar",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "backgroundColor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "borderColor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "borderType"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "cornerRadius"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "padding"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "positionType"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "textColor"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "HelpCenter"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      },
      {
        "condition": "hubEditMode",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "items": [
                  {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                  }
                ],
                "kind": "ListValue",
                "name": "cloudIds"
              }
            ],
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "cloudUrl"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4022831f47fbe75e743cc366c372d6f1434e902abda956a325a71b539f547a6f",
    "metadata": {},
    "name": "hubBootstrapWrapperQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "fc48fc6598d48c617cc16e7581ac6b2b";

export default node;
